import {
  computed,
} from "vue";

import ANotificationAPI from "aloha-vue/src/compositionAPI/ANotificationAPI";

import {
  tablePluginOptions,
} from "../plugin/PuxTablePlugin";
import {
  isNil,
} from "lodash-es";

export default function ErrorsAPI({
  changeModelFiltersLocalFromBadRequest = () => {},
}) {
  const {
    addNotification,
  } = ANotificationAPI();

  const msgError = computed(() => {
    return tablePluginOptions.value.global.project === "proandi" ?
      "_MSG_UNERWARTETER_FEHLER_" :
      "Ein unerwarteter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.";
  });

  const onErrorsByLoad = errors => {
    if (errors?.code === "ERR_CANCELED") {
      return;
    }
    if (isNil(errors)) {
      addNotification({
        type: "error",
        text: msgError.value,
      });
      return;
    }
    if (errors && errors.status === 400) {
      changeModelFiltersLocalFromBadRequest({ errors: errors.data });
    }
  };

  return {
    onErrorsByLoad,
  };
}
